import { InjectionToken } from '@angular/core';

export const WindowLocationToken = new InjectionToken<Location>('Window Location', {
  providedIn: 'root',
  factory: () => window.location,
});
